var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 520,
    viewBox: "0 0 520 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1484_5024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260 512C327.895 512 393.01 485.029 441.019 437.019C489.029 389.01 516 323.895 516 256C516 188.105 489.029 122.99 441.019 74.9807C393.01 26.9714 327.895 0 260 0C192.105 0 126.99 26.9714 78.9807 74.9807C30.9714 122.99 4 188.105 4 256C4 323.895 30.9714 389.01 78.9807 437.019C126.99 485.029 192.105 512 260 512ZM179 175C188.4 165.6 203.6 165.6 212.9 175L259.9 222L306.9 175C316.3 165.6 331.5 165.6 340.8 175C350.1 184.4 350.2 199.6 340.8 208.9L293.8 255.9L340.8 302.9C350.2 312.3 350.2 327.5 340.8 336.8C331.4 346.1 316.2 346.2 306.9 336.8L259.9 289.8L212.9 336.8C203.5 346.2 188.3 346.2 179 336.8C169.7 327.4 169.6 312.2 179 302.9L226 255.9L179 208.9C169.6 199.5 169.6 184.3 179 175Z",
    fill: "#EB742E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1484_5024",
    x: 0,
    y: 0,
    width: 520,
    height: 520,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1484_5024"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1484_5024",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllertIcon);
export default __webpack_public_path__ + "static/media/allert-Icon.2e26f08eb8d91b51a7a066348cad937e.svg";
export { ForwardRef as ReactComponent };